import classNames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import MaterialIcon, { IconNames } from '../../../../components/MaterialIcon/MaterialIcon';
import styles from './PhotoExamplesModal.module.scss';

export interface Example {
  captionKey?:
    | 'meterkast:photoExamplesBadCaption'
    | 'meterkast:photoExamplesGoodDetail'
    | 'meterkast:photoExamplesGoodOverview';
  detail?: boolean;
  src: string;
  wide?: boolean;
}

interface ExampleGroupProps {
  examples: Example[];
  heading: string;
  icon: IconNames;
  variant: 'bad' | 'good';
}

const ExampleGroup: FC<ExampleGroupProps> = ({ examples, heading, icon, variant }) => {
  const { t } = useTranslation();

  return (
    <section className={classNames(styles.group, styles[variant])}>
      <h3 className={styles.groupTitle}>
        <MaterialIcon name={icon} size={20} />
        <span>{heading}</span>
      </h3>
      <div className={styles.groupImages}>
        {examples.map(({ captionKey, detail, src, wide }) => (
          <figure className={classNames(styles.card, { [styles.detail]: detail, [styles.wide]: wide })} key={src}>
            <img alt={captionKey ? t(captionKey) : ''} src={src} />
            <figcaption className={styles.caption}>{captionKey ? t(captionKey) : ''}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};

export default ExampleGroup;
